import React from "react";
import styled from "styled-components";
import { I18n } from "@lingui/react";
import {
  TertiaryNav as Navigation,
  TabBar,
  Tab,
  spacing,
} from "@conserveit/blocks";
import { history } from "../../../browserHistory";
import { Link } from "../../../utils/routes/index";
import { navigate } from "../../../utils/routes/navigate";

interface Props {
  links: Link[];
  hasBottomBorder?: boolean;
}

const StyledTabBar = styled(TabBar)`
  padding: 0 ${spacing.extraLoose};
`;

export const TertiaryNav: React.FunctionComponent<Props> = ({
  links,
  hasBottomBorder = true,
}) => {
  const current = links.findIndex(({ href }) => {
    // * If subroute of path, return true
    const re = new RegExp(href);
    return re.exec(history.location.pathname) !== null;
  });

  if (current === -1) {
    return null;
  }

  return (
    <I18n>
      {({ i18n }) => (
        <Navigation hasBottomBorder={hasBottomBorder}>
          <StyledTabBar current={current}>
            {links.map(({ href, label }) => (
              <Tab key={href} onClick={navigate(href)}>
                {label(i18n)}
              </Tab>
            ))}
          </StyledTabBar>
        </Navigation>
      )}
    </I18n>
  );
};
